import global from "@/locales/pt-PT/global";
import error403 from "@/locales/pt-PT/errors/403";
import error404 from "@/locales/pt-PT/errors/404";
import error500 from "@/locales/pt-PT/errors/500";
import error503 from "@/locales/pt-PT/errors/503";
import error504 from "@/locales/pt-PT/errors/504";
import maintenance from "@/locales/pt-PT/auth/maintenance";
import toast from "@/locales/pt-PT/toast/toast";
import login from "@/locales/pt-PT/auth/login";
import onboarding from "@/locales/pt-PT/auth/onboarding";
import loginPageSteps from "@/locales/pt-PT/loginPageSteps";
import dashboard from "@/locales/pt-PT/dashboard/dashboard";
import account from "@/locales/pt-PT/account/account";
import mailbox from "@/locales/pt-PT/account/mailbox";
import bankstatement from "@/locales/pt-PT/account/bankstatement";
import myApps from "@/locales/pt-PT/my-apps/myApps";
import about from "@/locales/pt-PT/about/about";
import contactService from "@/locales/pt-PT/about/contactService";
import salesPromotions from "@/locales/pt-PT/sales/promotions";
import brochures from "@/locales/pt-PT/sales/brochures";
import shop from "@/locales/pt-PT/shop/data";
import priceList from "@/locales/pt-PT/shop/priceList";
import staff from "@/locales/pt-PT/dashboard/staff";
import promotions from "@/locales/pt-PT/promotions";
import points from "@/locales/pt-PT/points";
import trainings from "@/locales/pt-PT/trainings/trainings";
import vouchers from "@/locales/pt-PT/vouchers/vouchers";
import media from "@/locales/pt-PT/media/index";
import product from "@/locales/pt-PT/product/index";
import message from "@/locales/pt-PT/message/index";
import commitmentLetter from "@/locales/pt-PT/account/commitmentLetter";
import multiplicator from "@/locales/pt-PT/multiplicator";
import widgets from "@/locales/pt-PT/widgets/widgets";
import consents from "@/locales/pt-PT/consents/consents";
import investment from "@/locales/pt-PT/investment/data";
import kickback from "@/locales/pt-PT/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Imagens de produtos",
    BDriveLinkText: "Ligação para o portal de IMAGENS DE PRODUTOS",
  },
}

export default {
  locale: "pt-PT",
  messages,
};
